import React, { FC } from 'react';

import { TEXTS } from './texts';

import styles from './index.module.scss';

const CardSkeleton: FC = () => (
  <div className={styles.CardSkeletonBackground}>
    <div className={styles.CardSkeletonLine} />
    <div className={styles.CardSkeletonText}>{`${TEXTS.CARD_LOADING_TEXT}`}</div>
  </div>
);

export default React.memo(CardSkeleton);
